<h2 mat-dialog-title class="mb-0">
  Storico Date Invio Atto
  <small *ngIf="data?.incaricoLabel" class="text-muted">
    · {{ data.incaricoLabel }}
  </small>
</h2>

<mat-dialog-content class="dialog-content">
  <div *ngIf="loading" class="dialog-loading">
    <mat-progress-spinner
      diameter="36"
      mode="indeterminate"
    ></mat-progress-spinner>
  </div>

  <div *ngIf="!loading && error" class="dialog-error">
    {{ error }}
  </div>

  <mat-list *ngIf="!loading && !error && entries.length" class="entries-list">
    <mat-list-item *ngFor="let entry of entries; trackBy: trackByEntryId">
      <div class="entry-details">
        <div class="entry-date">
          {{
            entry.valore
              ? (entry.valore | dateFormat : "L")
              : "Data non disponibile"
          }}
        </div>
        <div class="entry-meta text-muted">
          Inserita il
          {{
            entry.created_at ? (entry.created_at | dateFormat : "L LT") : "-"
          }}
        </div>
      </div>
      <button
        mat-icon-button
        color="warn"
        matTooltip="Elimina data"
        (click)="remove(entry)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </mat-list-item>
  </mat-list>

  <div
    *ngIf="!loading && !error && !entries.length"
    class="dialog-empty text-muted"
  >
    Nessuna data invio atto registrata.
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" style="margin-bottom: -12px">
  <button mat-button (click)="closeWithResult()">Chiudi</button>
</mat-dialog-actions>
